<template>
  <AppLink
    class="cursor-pointer"
    :class="class_navbar_item"
    :data-test="$_.get(item, 'data_test')"
    :to="navigate_to"
    @click="goTo"
  >
    <p class="text-sm">
      {{ $t(item.title) }}
    </p>
  </AppLink>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NavbarItem',
  props: {
    is_primary_navbar: { type: Boolean },
    item: { type: Object, required: true },
    params: { type: Object, default: null },
  },
  computed: {
    class_navbar_item() {
      const class_selected = 'font-bold text-gray-500 underline';
      if (this.$route.name.startsWith(this.item.prefix)) {
        return this.is_primary_navbar ? 'font-bold text-white!' : class_selected;
      }
      return this.is_primary_navbar ? 'text-white!' : 'text-gray-500!';
    },
    navigate_to() {
      if (this.item.name === 'employeesClientProjects') {
        return {
          query: this.$route.query,
        };
      }
      return {
        name: this.item.name,
        params: this.params,
      };
    },
  },
  methods: {
    ...mapActions(['SET_CURRENT_PROJECT']),
    goTo() {
      if (this.item.name === 'employeesClientProjects') {
        this.$emit('openProjectSideBar');
      }
    },
  },
};
</script>
